module.exports = __webpack_public_path__ + "static/media/step2.b3ddd49a.webp";